document.addEventListener("DOMContentLoaded", function() {
  class SectionObserver {
    constructor() {
      this.sections = document.querySelectorAll('section');
      this.observer = new IntersectionObserver(this.handleIntersect.bind(this));
      this.observeSections();
    }

    handleIntersect(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        } else {
          entry.target.classList.remove('in-view');
        }
      });
    }

    observeSections() {
      this.sections.forEach(section => {
        this.observer.observe(section);
      });
    }
  }

  new SectionObserver();
});